<template>
  <FindInfoSlot>
    <template #findinfo-container>
      <h1 class="findidv2-title">비밀번호 변경</h1>
      <form @submit.prevent="() => {}" class="findinfo-form pw flex_column">
        <div class="findinfo-formgroup">
          <label class="findinfo-form-label">
            비밀번호
          </label>
          <div class="findinfo-form-infowrap">
            <InputBox
              :placeholder="'비밀번호 입력'"
              :inputtype="'password'"
              :value="password"
              @change-input="getPassword"
            />
            <ul class="password-check-listwrap">
              <li class="password-check-itemwrap" v-for="(item, index) in arrValidText" :key="index + item">
                <img
                  v-if="validPasswordArr[index]"
                  class="password-validation-img"
                  src="/media/images/icon/check-black-icon.png"
                  alt="check-gray-icon.png"
                />
                <img
                  v-else
                  class="password-validation-img"
                  src="/media/images/icon/check-gray-icon.png"
                  alt="check-gray-icon.png"
                />

                <span class="password-validation-text" :class="{ active: validPasswordArr[index] }">
                  {{ item }}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="findinfo-formgroup">
          <div class="findinfo-form-infowrap">
            <InputBox
              :placeholder="'비밀번호 확인'"
              :inputtype="'password'"
              :value="password2"
              @change-input="getPassword2"
            />
            <ul class="password-check-listwrap">
              <li class="password-check-itemwrap">
                <img
                  v-if="checkPassEqual()"
                  class="password-validation-img"
                  src="/media/images/icon/check-black-icon.png"
                  alt="check-gray-icon.png"
                />
                <img
                  v-else
                  class="password-validation-img"
                  src="/media/images/icon/check-gray-icon.png"
                  alt="check-gray-icon.png"
                />
                <span class="password-validation-text" :class="{ active: checkPassEqual() }">
                  비밀번호 일치
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="findinfo-btngroup">
          <BasicButton :disabled="!(passValid() && checkPassEqual())" @click-btn="changePassword()">
            <template #btnname>
              다음
            </template>
          </BasicButton>
        </div>
      </form>
    </template>
  </FindInfoSlot>
</template>
<script>
import FindInfoSlot from '@/slot/findInfoSlot.vue';
import InputBox from '@/components/InputBox/InputBox.vue';
import BasicButton from '@/components/BasicButton/BasicButton.vue';
import router from '@/router';
import axios from 'axios';
export default {
  components: {
    FindInfoSlot,
    InputBox,
    BasicButton
  },
  mounted() {
    if (!this.$route.params.authCode || !this.$route.params.email) {
      router.push('/findPass');
    }
  },
  data() {
    return {
      email: this.$route.params.email,
      authCode: this.$route.params.authCode,
      validPasswordArr: [false, false, false, false],
      arrValidText: ['영문포함', '숫자 포함', '특수문자 포함', '8~20자리'],
      validPassword: false,
      password: '',
      password2: ''
    };
  },
  methods: {
    getPassword(val) {
      this.password = val;
      const returnValid = this.$common.validPass(this.password);
      this.validPasswordArr = returnValid;
    },
    passValid() {
      return this.validPasswordArr.every(e => e);
    },
    checkPassEqual() {
      return this.password === this.password2 && this.password;
    },
    getPassword2(val) {
      this.password2 = val;
    },

    changePassword() {
      if (this.passValid()) {
        // 비밀번호 유효성 체크
        if (this.password === this.password2) {
          // 입력한 비밀번호 2개가 일치
          var email = this.email;
          var password = btoa(this.password);
          var authCode = this.authCode;

          axios
            .post('/api/user/updatePass', { email, password, authCode })
            .then(res => {
              // console.log(res.data.result);
              if (res.data.result) {
                router.replace({ name: 'ChangePassFinished' });
              } else {
                alert('비밀번호 변경에 실패했습니다.');
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          alert('새롭게 입력한 비밀번호가 일치하지 않습니다.');
        }
      } else {
        alert('유효성 실패');
      }
    }
  }
};
</script>
